const {CaseWhenConfiguration} = require("./configuration/case-when-configuration");
const {PreviewTab} = require("../preview-tab/preview-tab");
const CaseWhenStepTabs = {
    configuration: CaseWhenConfiguration,
    preview: PreviewTab,
};

exports.CaseWhenStepTabs = CaseWhenStepTabs;
